import type { ReactNode } from 'react'
import { AlertCircle, CheckCircle2, AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from '@/components/ui/alert'

interface AuthAlertProps {
  variant: 'error' | 'success' | 'warning'
  title?: string
  children: ReactNode
  action?: ReactNode
  className?: string
}

const variantStyles = {
  error: 'border-rose-200 bg-rose-50 text-rose-900 dark:border-rose-900/40 dark:bg-rose-950/30 dark:text-rose-100',
  success:
    'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-900/40 dark:bg-emerald-950/30 dark:text-emerald-100',
  warning:
    'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100',
}

const iconMap = {
  error: AlertCircle,
  success: CheckCircle2,
  warning: AlertTriangle,
}

export function AuthAlert({ variant, title, children, action, className }: AuthAlertProps) {
  const Icon = iconMap[variant]

  return (
    <Alert
      className={cn(
        variantStyles[variant],
        'rounded-xl',
        className,
      )}
    >
      <Icon className="size-4 shrink-0" />
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      <AlertDescription>
        <div className="space-y-2">
          {children}
          {action ? <div>{action}</div> : null}
        </div>
      </AlertDescription>
    </Alert>
  )
}
